import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './index';

function settingsRef(uid: string) {
  return doc(db, 'users', uid, 'settings', 'main');
}
function lastRunRef(uid: string) {
  return doc(db, 'users', uid, 'payrollRuns', 'last');
}

export async function loadSettings(uid: string): Promise<any | null> {
  try {
    const snap = await getDoc(settingsRef(uid));
    return snap.exists() ? snap.data() : null;
  } catch (e) {
    console.error('loadSettings error', e);
    return null;
  }
}

export async function saveSettings(uid: string, data: Record<string, any>) {
  try {
    await setDoc(settingsRef(uid), { ...data, updatedAt: serverTimestamp() }, { merge: true });
    return true;
  } catch (e) {
    console.error('saveSettings error', e);
    return false;
  }
}

export async function loadLastRun(uid: string): Promise<any | null> {
  try {
    const snap = await getDoc(lastRunRef(uid));
    return snap.exists() ? snap.data() : null;
  } catch (e) {
    console.error('loadLastRun error', e);
    return null;
  }
}

export async function saveLastRun(uid: string, data: Record<string, any>) {
  try {
    await setDoc(lastRunRef(uid), { ...data, savedAt: serverTimestamp() }, { merge: true });
    return true;
  } catch (e) {
    console.error('saveLastRun error', e);
    return false;
  }
}
